import { GrantsHistoryResponseType } from '../../../../services/grants/grantsHistory/types';
import { GetGrantHistoryPropsType } from './types';
import IGrantHistoryClient from './IGrantHistoryClient';
import { internalLogger } from '../../../../interface/v1/clientOsLogger';
import { StratusClient } from '@jarvis/web-stratus-client/dist/src/clients/stratus-client';
import { Stack } from '../../../../core/types/stratus';
import { getStratusBaseUrl } from '../../../stackUtils';

export default class GrantHistoryClient
  extends StratusClient
  implements IGrantHistoryClient
{
  apiName = 'ws-hp.com/grant-history';
  apiVersion = '1';
  grantsEndpoint = '/grants';

  public static getBaseUrl(stack: Stack): string {
    return `${getStratusBaseUrl(stack)}/grant-history`;
  }

  public async getGrantHistory(
    options: GetGrantHistoryPropsType
  ): Promise<GrantsHistoryResponseType> {
    const { offset = 0, limit, tenantId = '' } = options;
    const params = {
      limit,
      tenantId
    };

    if (offset) {
      params['offset'] = offset;
    }

    try {
      const response = await this.jarvisWebHttpInstance
        .get({
          url: this.grantsEndpoint
        })
        .catch((err) => {
          internalLogger?.error(err);
          return {
            data: { resourceList: [], totalCount: 0, currentReturnCount: 0 }
          };
        });

      return response.data as GrantsHistoryResponseType;
    } catch (error) {
      if (error.response?.status === 404) {
        internalLogger.log('record not found');
        return {
          results: [],
          totalRecords: 0
        } as GrantsHistoryResponseType;
      } else {
        internalLogger.error(error);
      }
    }
  }
}
